import { ReducerAction } from 'store/modules/types';

import { Types, IRequestConsultaReabilitacao } from './types';

export function consultaReabilitacaoRequest(
	data: IRequestConsultaReabilitacao,
): ReducerAction {
	return {
		type: Types.CONSULTA_REABILITACAO,
		payload: data,
	};
}
export function consultaReabilitacaoSuccess(payload: object): ReducerAction {
	return {
		type: Types.CONSULTA_REABILITACAO_SUCCESS,
		payload,
	};
}
export function consultaReabilitacaoFailure(payload: boolean): ReducerAction {
	return {
		type: Types.CONSULTA_REABILITACAO_FAILURE,
		payload,
	};
}
